"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketingPurposeSubCategory = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
exports.MarketingPurposeSubCategory = (0, type_utils_1.makeEnum)({
    /** Fallback sub purpose */
    Marketing: 'MARKETING',
});
//# sourceMappingURL=marketing.js.map